import React from "react";
import { Offset } from "../../../util/TimeUtil";
import { Typography } from "best-common-react";

const TimeValue = ({ unit, children }) => (
  <div className="d-flex flex-column justify-content-center align-items-center">
    <Typography variant="bodySmall" elementStyles={{ weight: "bold", color: "inherit" }}>
      {children}
    </Typography>
    <Typography variant="bodySmall" elementStyles={{ weight: "bold", color: "inherit" }}>
      {unit}
    </Typography>
  </div>
);

type TimeRemainingProps = {
  offset?: Offset;
  isPersonal: boolean;
};

const TimeRemaining = ({
  offset = {
    days: 0,
    hours: 0,
    minutes: 0,
    text: "",
  },
  isPersonal,
}: TimeRemainingProps) => {
  const { days, hours, minutes, text } = offset;
  return (
    <div
      className="d-flex flex-column bcr-gap-1"
      style={{ color: isPersonal ? "var(--color-primary)" : "var(--color-non-text-blue)" }}
    >
      <div className="d-flex justify-content-between">
        <TimeValue unit="days">{days}</TimeValue>
        <TimeValue unit="hrs">{hours}</TimeValue>
        <TimeValue unit="mins">{minutes}</TimeValue>
      </div>
      <Typography variant="bodySmall" elementStyles={{ weight: 300, color: "inherit" }}>
        {text}
      </Typography>
    </div>
  );
};

export default TimeRemaining;
